/* eslint-disable react/no-deprecated */

import React from "react"
import classnames from "classnames"
import styles from "./ShareForm.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import {
  InputText,
  InputEmail,
  Interactive,
  InputCheckBox,
  TickModalIcon,
  A,
  Button,
  H2,
  H4,
  Content,
  FormGroup,
  Space,
  PlusCircleIcon,
  RemoveCircleIcon,
  Visible
} from "AtomicComponents"
import { Image, AlertList, InputSearchable, DealerSearch } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formSetDefaultValues, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import { DealerSearchBoxNZ } from "components"

class ShareForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        // postcode: {
        //   validations: {
        //     required: MESSAGES.ADDRESS1_REQUIRED
        //   }
        // },
        region: {
          validations: {
          }
        },
        preferredDealer: {
          validations: {}
        },
        message: {
          validations: {}
        },
        optIn: {
          validations: {
            required: MESSAGES.OPTIN_REQUIRED
          }
        },
        recipient0firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        recipient0email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        privacyPolicy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      recipients: [0],
      success: false,
      errorMessage: null
    }
  }

  componentDidMount() {
    const { location } = this.props

    if (location && location.postcode) {
      formSetDefaultValues(this, {
        postcode: location.postcode
      })
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { endPoint, namePlate, bodyStyle, location = {}, safetyModelExcess = null, buildUrl, findDealerUrl, compareUrl } = this.props
        const { form } = this.state
        const recipients = []
        this.state.recipients.map((item, index) => {
          recipients.push({
            firstName: form[`recipient${item}firstName`].value,
            email: form[`recipient${item}email`].value
          })
        })
        await fetchAPI({
          method: "POST",
          url: endPoint,
          body: {
            sender: {
              email: form.email.value,
              firstName: form.firstName.value
            },
            message: form.message.value,
            // postcode: form.postcode.value.postcode || location.postcode || "",
            namePlate,
            bodyStyle,
            recipients,
            safetyModelExcess,
            buildUrl,
            findDealerUrl,
            compareUrl,
            optedInDealer: form.optIn.value,
            dealerCode: form.preferredDealer.value.dealerCode,
            dealerPostCode: form.preferredDealer.value.postCode,
            state: form.preferredDealer.value.state || localStorage.getItem('selectedRegion') || ''
          }
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg, words } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              words: (words && words.split(",")) || [],
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: `${this.props.gtmEvents ? this.props.gtmEvents.category + " | " : ""}Share Form`,
                pageAction: `${this.props.gtmEvents ? this.props.gtmEvents.action + " - " : ""}Clicked "SEND" - Successfully submitted.`
              })
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            words: (response.words && response.words.split(",")) || [],
            loading: false
          })
        })
      })
    }
  }

  recipient(id, index) {
    const { fullWidth } = this.props
    const { form, recipients } = this.state

    return (
      <div key={id}>
        <div>
          {
            id !== 0 &&
            <div
              className={classnames({
                [styles.ShareFormTrigger]: true,
                [styles.floating]: true
              })}
              onClick={() => {
                const newRecipientArray = recipients.filter(item => item !== id)
                const newForm = form
                delete newForm[`recipient${id}firstName`]
                delete newForm[`recipient${id}email`]

                this.setState({
                  recipients: newRecipientArray,
                  fields: newForm
                })
              }}>
              <RemoveCircleIcon />
              <Visible visible={["screen"]}>
                <Interactive>
                  Remove
                </Interactive>
              </Visible>
            </div>
          }
          <H4>RECIPIENT {index + 1}</H4>
        </div>
        <FormGroup>
          <InputText
            name={`recipient${id}firstName`}
            label="First Name"
            {...fromLinkInputs(this, `recipient${id}firstName`)}
            onBlur={() => {
              gtmHandler({
                pageCategory: "Share Form",
                pageAction: "Share Form - Entered \"FIRSTNAME\""
              })
            }}
          />
        </FormGroup>
        <FormGroup fullWidth={fullWidth}>
          <InputEmail
            name={`recipient${id}email`}
            label="Email"
            {...fromLinkInputs(this, `recipient${id}email`)}
            onBlur={() => {
              gtmHandler({
                pageCategory: "Share Form",
                pageAction: "Share Form - Entered \"EMAIL\""
              })
            }}
          />
        </FormGroup>
      </div>
    )
  }

  selectDealer = (dealer) => {
    // no search, use the selected dealer only for the radio inputs
    // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
    this.refs.dealerSearchComp.setState({
      dealers: [dealer],
      selected: dealer,
      loading: false
    })
  }

  render() {
    const {
      buttonText = "Send",
      heading = "Share",
      imageSrc,
      namePlate,
      description,
      optInMessage,
      privacyPolicy,
      privacyPolicyLink,
      successMessage,
      closeButtonText = "Close",
      fullWidth = false,
      handleClose,
      initialLocations = [],
      dealersEndPoint = "/api/dealer-search",
      dealerSearchEndPoint = "/api/dealers"
    } = this.props
    const { loading, success, errorMessage, recipients, form, words } = this.state

    if (words && words.length > 0) {
      let newForm = form

      words.map(item => {
        if (item === "FirstName") {
           newForm.firstName.isValid = true
           newForm.firstName.message = MESSAGES.PROFANITY_FILTER
        }
        if (item === "Message") {
           newForm.message.isValid = true
           newForm.message.message = MESSAGES.PROFANITY_FILTER
        }
        if (item === "Email") {
           newForm.email.isValid = true
           newForm.email.message = MESSAGES.PROFANITY_FILTER
        }
        // Looking for recipients
        let recipient = item.split(".")
        if (recipient[0] && recipient[0].includes("Recipient")) {
          let recipientsNumber = Number(recipient[0].replace("Recipient", "")) - 1

          newForm[`recipient${recipientsNumber}${recipient[1] === "Email" ? "email" : "firstName"}`].isValid = true
          newForm[`recipient${recipientsNumber}${recipient[1] === "Email" ? "email" : "firstName"}`].message = MESSAGES.PROFANITY_FILTER
        }
      })
      this.setState({
        form: newForm,
        words: []
      })
    }

    if (success) {
      return (
        <div className={classnames({ [styles.ShareForm]: true  })}>
          <div className={classnames({ [styles.ShareFormForm]: true })}>
            <FormGroup fullWidth={fullWidth}>
              <TickModalIcon style={{ width: "2.25em", height: "2.25em", margin: "0 auto" }} />
              <H2>{"Success"}</H2>
              <Content
                xmlString={successMessage ||
                  `A link to your vehicle${Array.isArray(namePlate) && namePlate.length > 1 ? "s" : ""} was sent to:<br />
                  ${
                  recipients.map(item => {
                    return `
                        <strong>
                          ${form[`recipient${item}email`].value}
                        </strong>
                      `
                  }).reduce((output, recipient, index) => {
                    return `
                      <span>${output} ${index > 0 ? " and " : ""} ${recipient}</span>`
                  }, "<span />")
                  }`
                } />
              {
                imageSrc &&
                <div className={classnames({ [styles.ShareFormImage]: true })}>
                  {imageSrc.map((img, index) => <Image key={index} src={img} />)}
                </div>
              }
              <Space />
              <Button styleName="blackOutlined" onClick={handleClose} fullWidth>
                {closeButtonText}
              </Button>
            </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({ [styles.ShareForm]: true })}>
        <div className={classnames({ [styles.ShareFormForm]: true })}>
          <form method="POST" onSubmit={this._handleSubmit} noValidate>
            <FormGroup fullWidth={fullWidth}>
              <H2>{heading}</H2>
              <Content xmlString={description} />
              <Space />
            </FormGroup>
            <FormGroup fullWidth={fullWidth}>
              <InputText
                name="firstName"
                label="First Name"
                {...fromLinkInputs(this, "firstName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - Entered \"FIRSTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup fullWidth={fullWidth}>
              <InputEmail
                name="email"
                label="Email"
                {...fromLinkInputs(this, "email")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - Entered \"EMAIL\""
                  })
                }}
              />
            </FormGroup>

            {/* <FormGroup fullWidth={fullWidth}>
              <InputSearchable
                name="postcode"
                type="postcode"
                label="Postcode/Suburb"
                {...fromLinkInputs(this, "postcode")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - Entered \"POSTCODE\""
                  })
                }}
              />
            </FormGroup> */}

            <DealerSearchBoxNZ
              searchType="SALES"
              noMap={true}
              selectDealerVariant={true}
              selectDealer={this.selectDealer}
            />

            <FormGroup>
              <DealerSearch
                dealersEndPoint={dealersEndPoint}
                endpoint={dealerSearchEndPoint}
                disabled={!form.region.value || !(form.region.value.postcode || form.region.value.value)}
                type="Sales"
                name="preferredDealer"
                postcode={form.region.value && form.region.value.postcode || (initialLocations && initialLocations[0] && initialLocations[0].postCode)}
                dealerCode={form.region.value && form.region.value.value}
                ref="dealerSearchComp"
                {...fromLinkInputs(this, "preferredDealer")} />
            </FormGroup>

            <FormGroup fullWidth={fullWidth}>
              <InputText
                name="message"
                label="Your message"
                {...fromLinkInputs(this, "message")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - Entered \"MESSAGE\""
                  })
                }}
              />
            </FormGroup>
            {
              recipients.map((recipient, index) => {
                return this.recipient(recipient, index)
              })
            }
            {
              recipients.length < 5 &&
              <FormGroup fullWidth={fullWidth}>
                <div
                  className={classnames({ [styles.ShareFormTrigger]: true })}
                  onClick={() => {
                    const newForm = form
                    newForm[`recipient${recipients[recipients.length - 1] + 1}firstName`] = {
                      validations: {
                        required: MESSAGES.FIRSTNAME_REQUIRED
                      }
                    }
                    newForm[`recipient${recipients[recipients.length - 1] + 1}email`] = {
                      validations: {
                        required: MESSAGES.EMAIL_REQUIRED,
                        email: MESSAGES.EMAIL_INVALID
                      }
                    }
                    const newRecipientArray = recipients
                    newRecipientArray.push(recipients[recipients.length - 1] + 1)
                    this.setState({
                      form: newForm,
                      recipients: newRecipientArray
                    })
                  }}>
                    <PlusCircleIcon />
                    <Interactive>
                    Add another recipient
                    </Interactive>
                  </div>
              </FormGroup>
            }
            <FormGroup fullWidth={fullWidth} show checkbox>
              <InputCheckBox
                name="optIn"
                label={optInMessage || "I acknowledge that Mazda or Mazda dealers may send me further information about Mazda products or services."}
                {...fromLinkInputs(this, "optIn", () => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - checked \"Opt in\""
                  })
                })}
              />
            </FormGroup>
            <Space />
            <FormGroup fullWidth={fullWidth} show checkbox>
              <InputCheckBox
                name="privacyPolicy"
                label={
                  <span>
                    {privacyPolicy || "I have read and agree to Mazda New Zealand's "}
                    <A
                      href={privacyPolicyLink || "/privacy-policy/"}
                      onClick={() => {
                        gtmHandler({
                          pageCategory: "Share Form",
                          pageAction: "Share Form - Clicked \"PRIVACYPOLICY\""
                        })
                      }}
                      external>
                      <nobr>Privacy Policy</nobr>
                    </A>
                  </span>
                }
                {...fromLinkInputs(this, "privacyPolicy", () => {
                  gtmHandler({
                    pageCategory: "Share Form",
                    pageAction: "Share Form - checked \"Privacy policy\""
                  })
                })}
              />
            </FormGroup>
            <Space />
            <Space />
            <FormGroup fullWidth={fullWidth}>
              <AlertList data={errorMessage} />
              <Button styleName="black" loading={loading} fullWidth {...formLinkSubmit(this, this._handleSubmit)}>
                {buttonText}
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default ShareForm



// WEBPACK FOOTER //
// ./src/AtomicContainers/ShareForm/ShareForm.jsx